<h3>How to redeem</h3>
<div class="new-card how-to-redeem">
  <div class="redemtion-info" *ngIf="redeemSteps?.length">
    <div class="step" *ngFor="let step of redeemSteps">
      <img class="image" [src]="s3BucketUrl + '/voucher-redemption-details/icons/' + step.image" />
      <div class="info">
        <div class="title" [innerHTML]="step.title | safeHtml"></div>
        <div class="desc" [innerHTML]="step.body | safeHtml"></div>
      </div>
    </div>
  </div>
  <div class="redemtion-info" *ngIf="!redeemSteps?.length">
    <div class="step">
      <img class="image" src="/assets/images/ocd/1.svg" />
      <div class="info">
        <div class="title">1. Copy the voucher</div>
        <div class="desc">Copy the voucher code and save them. Your voucher codes are also available in 'My Accounts'.</div>
      </div>
    </div>
    <div class="step">
      <div class="custom-image" *ngIf="allSameMerchant">
        <div class="logo-icon" [style.background-image]="'url(' + s3BucketUrl + '/logo-icons/' + (application.MerchantName | lowercase) + '-logo-icon.png)'"></div>
      </div>
      <img class="image" *ngIf="!allSameMerchant" src="/assets/images/ocd/2.svg" />
      <div class="info">
        <div class="title">2. Visit the store </div>
        <div class="desc">Visit the online/offline store where you want to redeem it. Please ensure that the order is still available at the store.</div>
      </div>
    </div>
    <div class="step">
      <img class="image" src="/assets/images/ocd/3.svg" />
      <div class="info">
        <div class="title">3. Use it during checkout or add to pay / Giftcard / Credit balance</div>
        <div class="desc">Use the voucher for single or multiple purchases</div>
      </div>
    </div>
    <div class="step"> 
      <div class="info note">
        📌 Note: We have sent the vouchers to your email id and are also available under ‘My Accounts’
      </div>
    </div>
  </div>
</div>